import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../shared/models/response.model';
import { LivrableUpdateRequest } from './request/update-request';
import { RéférentielLivrable } from '../administration/gestion-référentiels/models/référentiel-livrable.model';

@Injectable({
  providedIn: 'root',
})
export class RéférentielLivrableService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/référentiels-livrables';

  findAll = () => this.#http.get<Response<RéférentielLivrable>>(this.BASE_URL);

  update = (id: string, data: LivrableUpdateRequest) => this.#http.patch(this.BASE_URL + '/' + id, data);
}
